import moment from 'moment'

const getTimeFormat = () => moment().format('YYYYMMDDHHmmss')

export const getFileNamePosSale = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.pos')}-${$t('sidebar.possale')}.${fileType}`
}

export const getFileNamePosCashier = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.pos')}-${$t('sidebar.poscashier')}.${fileType}`
}

export const getFileNamePosSku = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.pos')}-${$t('sidebar.posproduct')}.${fileType}`
}

export const getFileNamePosCategory = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.pos')}-${$t('sidebar.inventorybalance')}.${fileType}`
}

export const getFileNameStockInventoryBalance = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.inventory')}-${$t('sidebar.inventorybalance')}.${fileType}`
}

export const getFileNameStockInventoryValue = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.inventory')}-${$t('sidebar.inventoryvalue')}.${fileType}`
}

export const getFileNameStockInventoryBehavior = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.inventory')}-${$t('sidebar.inventorybehavior')}.${fileType}`
}

export const getFileNameStockInventoryInOut = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.inventory')}-${$t('sidebar.inventoryinout')}.${fileType}`
}

export const getFileNamePaymentMethod = ($t, fileType) => {
  return `${getTimeFormat()}-${$t('sidebar.pos')}-${$t('sidebar.pospaymentmethod')}.${fileType}`
}

export const getFileNameTransactionDetail = ($t, fileType, psCode) => {
  return `${psCode}.${fileType}`
}

export const getFileName = ($t, fileType, sidebarAppName, sidebarSubModuleName) => {
  return `${getTimeFormat()}-${$t(sidebarAppName)}-${$t(sidebarSubModuleName)}.${fileType}`
}



// WEBPACK FOOTER //
// ./src/helpers/exportFormater.js